module.exports = __webpack_public_path__ + "img/support_a15.91460d7a.png";